export default __webpack_public_path__ + "static/media/validation.42bc5584.gif";